module.exports = __webpack_public_path__ + "static/media/Bioga.12f29226.svg";